export default __webpack_public_path__ + "static/media/doc.a15acc34.svg";